module.exports = __webpack_public_path__ + "static/media/right-icons.743fd9b9.svg";